import { render, staticRenderFns } from "./Lottery.GiftDisplayer.vue?vue&type=template&id=54b73b0e&scoped=true&"
import script from "./Lottery.GiftDisplayer.vue?vue&type=script&lang=js&"
export * from "./Lottery.GiftDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./Lottery.GiftDisplayer.vue?vue&type=style&index=0&id=54b73b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b73b0e",
  null
  
)

export default component.exports